export const PAYROLL_GET_ALL = "V1_PAYROLL_GET_ALL";
export const PAYROLL_GET_ALL_BY_COID = "V1_PAYROLL_GET_ALL_BY_COID";
export const UPDATE_PAYROLL = "V1_UPDATE_PAYROLL";
export const BULK_DISBURSED = "V1_BULK_DISBURSED";
export const REVERT_PROCESSING = "V1_REVERT_PROCESSING";
export const GENERATE_RHB = "V1_GENERATE_RHB";
export const UPDATE_BULK_PAYROLL = "V1_UPDATE_BULK_PAYROLL";
export const UPDATE_REMARKCOUNT_PAYROLL = "V1_UPDATE_REMARKCOUNT_PAYROLL";
export const UPDATE_PAYROLL_FILE_CLOSE = "V1_UPDATE_PAYROLL_FILE_CLOSE";